module.exports = __webpack_public_path__ + "img/bench.3ab92fa2.jpg";